/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, USHIO){
	// 「条件を絞り込む」(tablet, pc)
	const $filterBlock = $('.prod-filterBlock');
	const $filterBtn = $('.prod-filterBtn');
	const $filterCloseBtn = $('.js-filterClose');
	const $filterTit = $('.prod-filter-tit');
	const $filterList = $('.prod-filter-list');
	const a = 'is-active';

	$filterBtn.on('click', (e) => {
		$filterBlock.addClass(a);
		$('.header-nav').removeClass(a);
		$('.header-menuBtn').removeClass(a);
		const scrTop = window.pageYOffset;
		$('body').addClass('is-fixed');
		$('body').css('top', - scrTop);
	});

	$filterBlock.on('click', (e) => {
		if(!$(e.target).closest('.prod-filterBlock-inner').length) {
			$filterBlock.removeClass(a);
			if($('body').hasClass('is-fixed')){
				$('body').removeClass('is-fixed');
				window.scroll(0, $('body').css('top').replace('-', '').replace('px', ''));
				$('body').css('top', 'auto');
			}
		}
	});
	$filterCloseBtn.on('click', (e) => {
		$filterBlock.removeClass(a);
		if($('body').hasClass('is-fixed')){
			$('body').removeClass('is-fixed');
			window.scroll(0, $('body').css('top').replace('-', '').replace('px', ''));
			$('body').css('top', 'auto');
		}
	});

	$filterTit.on('click', (e) => {
		$(e.target).toggleClass(a);
		$(e.target).next($filterList).toggleClass(a);
	});

	// テーブルthead・tbodyスクロール連動
	let scrolling = false;
	const tableHead = $('.js-theadWrap .mod-tblWrap');
	const tableBody = $('.js-tbodyWrap .mod-tblWrap');
	tableHead.scroll(function(){
		if(scrolling) {
			scrolling = false;
			return true;
		}
		scrolling = true;
		tableBody.scrollLeft(tableHead.scrollLeft());
	});
	tableBody.scroll(function(){
		if(scrolling) {
			scrolling = false;
			return true;
		}
		scrolling = true;
		tableHead.scrollLeft(tableBody.scrollLeft());
	});
	$('.js-tableWrap').css('padding-top', tableHead.outerHeight());
	$(window).scroll(function(e){
		let $this = $(e.currentTarget);
		let thisScroll = $this.scrollTop();
		let tableHeadTop = $('.js-tableWrap').offset().top - $('.header').outerHeight();
		// console.log(tableHeadTop, thisScroll);
		if(thisScroll > tableHeadTop) {
			$('.js-theadWrap').addClass('is-fixed');
		} else {
			$('.js-theadWrap').removeClass('is-fixed');
		}
	});

	// ＜共通＞JSON取得 ---------------------------------------------------
	let directory = location.pathname.split('/')[2];
	let lang = location.pathname.split('/')[1];
	let yesText,yesTextMonitor,noText,noTextMonitor,inquiryText;
	if(lang === 'jp') {
		yesText = 'あり';
		yesTextMonitor = 'あり';
		noText = 'なし';
		noTextMonitor = 'なし';
		inquiryText = 'お問い合わせ';
	} else {
		yesText = 'Present';
		yesTextMonitor = 'With';
		noText = 'None';
		noTextMonitor = 'Without';
		inquiryText = 'Inquiry';
	}
	// led製品用
	const getJSONled = () => {
		return $.getJSON(`/${lang}/ajax/products/led.json`);
	};
	// led製品パラメータ指定用
	const getJSONledParameter = (_parameter) => {
		return $.getJSON(`/${lang}/ajax/products/led.json${_parameter}`);
	};
	// ＜共通＞昇順・降順ソート ---------------------------------------------------
	// 昇順
	const itemAscendingSort = (_list, _key) => {
		_list.sort(function(itemA, itemB){
			if(itemA[_key] < itemB[_key]) return -1;
			if(itemA[_key] > itemB[_key]) return 1;
			return 0;
		});
	};
	// 降順
	const itemDescendingSort = (_list, _key) => {
		_list.sort(function(itemA, itemB){
			if(itemA[_key] > itemB[_key]) return -1;
			if(itemA[_key] < itemB[_key]) return 1;
			return 0;
		});
	};
	// ＜共通＞ローディング用変数 ---------------------------------------------------
	const searchBlock = $('.js-product-search-block');
	// ＜共通＞もっとみる用変数 ---------------------------------------------------
	let count = 0;
	let moreItemArray = [];
	let moreItem;
	// ＜共通＞setjsonList ---------------------------------------------------
	const setJSONList = (_data) => {
		let itemList = [];
		// タグ（波長用）
		let wavelengthsItem;
		let wavelengthsKeys = [];
		// タグ（波長以外用）
		let applicationsItem;
		let applicationsKeys = [];
		// led・ld、jsファイル切り分け済み
		for(let i = 0; i < _data.cms_product_Base_category.length; i++) {
			// タグ用keyを配列に格納
			wavelengthsKeys = [];
			wavelengthsItem = _data.cms_product_Base_category[i].ent_pb_wavelengths;
			$.each(wavelengthsItem, function(index, val){
				wavelengthsKeys.push(val._key);
			});
			// タグ用keyを配列に格納
			applicationsKeys = [];
			applicationsItem = _data.cms_product_Base_category[i].ent_pb_applications;
			$.each(applicationsItem, function(index, val){
				applicationsKeys.push(val._key);
			});
			itemList[i] = {
				ent_pled_name: _data.cms_product_Base_category[i].ent_pled_name, // 製品名
				_key: _data.cms_product_Base_category[i]._key, // 製品ID
				ent_pled_order: _data.cms_product_Base_category[i].ent_pled_order, // 表示順
				ent_pled_wave_length: _data.cms_product_Base_category[i].ent_pled_wave_length, // 発振波長
				ent_pled_package_type: _data.cms_product_Base_category[i].ent_pled_package_type, // パッケージタイプ
				ent_pled_package_family: _data.cms_product_Base_category[i].ent_pled_package_family, // パッケージファミリー
				ent_pled_package_size: _data.cms_product_Base_category[i].ent_pled_package_size, // パッケージサイズ
				ent_pled_output_power: _data.cms_product_Base_category[i].ent_pled_output_power, // 出力ランク
				ent_pled_forward_current: _data.cms_product_Base_category[i].ent_pled_forward_current, // 定格電流
				ent_pled_total_radiated_power: _data.cms_product_Base_category[i].ent_pled_total_radiated_power, // 光出力
				ent_pled_maximum_forward_current: _data.cms_product_Base_category[i].ent_pled_maximum_forward_current, // 最大定格電流（DC)
				ent_pled_maximum_pulse_forward_current: _data.cms_product_Base_category[i].ent_pled_maximum_pulse_forward_current, // 最大定格電流(Pulse)
				ent_pled_viewing_half_angle: _data.cms_product_Base_category[i].ent_pled_viewing_half_angle, // 配光角（Θ1/2）
				ent_pled_half_width: _data.cms_product_Base_category[i].ent_pled_half_width, // 波長スペクトルの半値幅
				ent_pled_3d_data: _data.cms_product_Base_category[i].ent_pled_3d_data, // 3D Data（例）aaa_3d.zip
				ent_pled_ray_file: _data.cms_product_Base_category[i].ent_pled_ray_file, // Ray File（例）aaa_ray.zip無い場合は空欄
				ent_pled_pdf_file: _data.cms_product_Base_category[i].ent_pled_pdf_file, // PDF FIle（例）aaa.pdf無い場合は空欄
				ent_pled_discontinued_production: _data.cms_product_Base_category[i].ent_pled_discontinued_production, // 廃止品（ディスコンの場合は「1」ディスコンではない場合は「0」NRNDの場合は「2」）
				wavelengthsKeys: wavelengthsKeys, // 波長タグkey
				applicationsKeys: applicationsKeys, // アプリケーションタグkey
			};
		}
		return itemList;
	};
	// ＜共通＞html出力部分（20件） ---------------------------------------------------
	let htmlBlock = '';
	if($(window).width() < 1024) {
		htmlBlock = $('.js-json-list-sp');
	} else {
		htmlBlock = $('.js-json-list-pc');
	}
	const setHtml = (_list) => {
		moreItemArray = [];
		$('.js-json-list-pc tr').remove();
		$('.js-json-list-sp tr').remove();
		searchBlock.removeClass('is-noItem');
		// リスト0件ならテキスト表示
		if(!_list.length) {
			searchBlock.addClass('is-noItem');
		}
		if(!(_list.length < 21)) {
			$('.js-product-more-button').removeClass('di_none');
		} else {
			$('.js-product-more-button').addClass('di_none');
		}
		if(directory === 'laser') {
			$('.js-product-more-button').addClass('di_none');
		}
		// 初期表示20件
		for(let i = 0; i < _list.length; i++) {
			let htmlbox;
			if(i < 20) {
				// led・ld、jsファイル切り分け済み
				if(directory === 'led') {
					// pc・spだし分け
					if($(window).width() < 1024) {
						htmlbox = '<tr>'+
						'<td class="prod-result-name ta_left">'+
						'<ul class="pure-g pure-g-align_center">'+
						'<li class="pure-u-4-5 pr10">';
						// ディスコンだし分け
						if(!(_list[i].ent_pled_discontinued_production == '0')) {
							if(!(_list[i].ent_pled_discontinued_production == '1')) {
								htmlbox += '<span class="prod-result-name_tag" style="background:#ffff00;color: #000;">NRND</span>'+
								'<span class="prod-result-name_txt">'+_list[i].ent_pled_name+'</span>'+
								'</li>'+
								'<li class="pure-u-1-5">';
							} else {
								htmlbox += '<span class="prod-result-name_tag">DISCONTINUED</span>'+
								'<span class="prod-result-name_txt">'+_list[i].ent_pled_name+'</span>'+
								'</li>'+
								'<li class="pure-u-1-5">';
							}
						} else {
							htmlbox += '<span class="prod-result-name_txt">'+_list[i].ent_pled_name+'</span>'+
							'</li>'+
							'<li class="pure-u-1-5">';
						}
						// PDFだし分け
						if(!(_list[i].ent_pled_pdf_file === '')) {
							htmlbox += '<a href="/'+lang+'/products/product_file/file/'+_list[i].ent_pled_pdf_file+'" target="_blank" class="prod-result-name_pdf">'+
							'<img src="/assets/images/icon-pdf.png">'+
							'</a>'+
							'</li>'+
							'</ul>';
						} else {
							htmlbox += '</li>'+
							'</ul>';
						}
						htmlbox += '<a href="https://member.ushio.co.jp/'+lang+'/members/contact/product-led/=/product='+_list[i]._key+'" class="prod-result-contactBtn" target="_blank">'+inquiryText+'</a></td>'+
						'<td>'+_list[i].ent_pled_package_type+'</td>'+
						'<td>'+_list[i].ent_pled_total_radiated_power+'</td>'+
						'</tr>';
					} else {
						htmlbox = '<tr>'+
						'<td class="prod-result-name ta_left">'+
						'<ul class="pure-g pure-g-align_center">'+
						'<li class="pure-u-4-5 pr10">';
						// ディスコンだし分け
						if(!(_list[i].ent_pled_discontinued_production == '0')) {
							if(!(_list[i].ent_pled_discontinued_production == '1')) {
								htmlbox += '<span class="prod-result-name_tag" style="background:#ffff00;color: #000;">NRND</span>'+
								'<span class="prod-result-name_txt">'+_list[i].ent_pled_name+'</span>'+
								'</li>'+
								'<li class="pure-u-1-5">';
							} else {
								htmlbox += '<span class="prod-result-name_tag">DISCONTINUED</span>'+
								'<span class="prod-result-name_txt">'+_list[i].ent_pled_name+'</span>'+
								'</li>'+
								'<li class="pure-u-1-5">';
							}
						} else {
							htmlbox += '<span class="prod-result-name_txt">'+_list[i].ent_pled_name+'</span>'+
							'</li>'+
							'<li class="pure-u-1-5">';
						}
						// PDFだし分け
						if(!(_list[i].ent_pled_pdf_file === '')) {
							htmlbox += '<a href="/'+lang+'/products/product_file/file/'+_list[i].ent_pled_pdf_file+'" target="_blank" class="prod-result-name_pdf">'+
							'<img src="/assets/images/icon-pdf.png">'+
							'</a>'+
							'</li>'+
							'</ul>'+
							'</td>';
						} else {
							htmlbox += '</li>'+
							'</ul>'+
							'</td>';
						}
						htmlbox += '<td>'+_list[i].ent_pled_wave_length+'</td>'+
						'<td>'+_list[i].ent_pled_package_type+'</td>'+
						'<td>'+_list[i].ent_pled_package_family+'</td>'+
						'<td>'+_list[i].ent_pled_package_size+'</td>'+
						'<td>'+_list[i].ent_pled_output_power+'</td>'+
						'<td>'+_list[i].ent_pled_forward_current+'</td>'+
						'<td>'+_list[i].ent_pled_total_radiated_power+'</td>'+
						'<td>'+_list[i].ent_pled_maximum_forward_current+'</td>'+
						'<td>'+_list[i].ent_pled_maximum_pulse_forward_current+'</td>'+
						'<td>'+_list[i].ent_pled_viewing_half_angle+'</td>'+
						'<td>'+_list[i].ent_pled_half_width+'</td>';
						// 3D Dataだし分け
						if(!(_list[i].ent_pled_3d_data === '')) {
							htmlbox += '<td><a href="/'+lang+'/products/product_file/file/'+_list[i].ent_pled_3d_data+'" class="mod-link01" target="_blank">'+yesText+'</a></td>';
						} else {
							htmlbox += '<td>'+noText+'</td>';
						}
						// レイファイルだし分け
						if(!(_list[i].ent_pled_ray_file === '')) {
							htmlbox += '<td><a href="https://ushio-inc.s3-ap-northeast-1.amazonaws.com/led/rayfile/'+_list[i].ent_pled_ray_file+'" class="mod-link01" target="_blank">'+yesText+'</a></td>';
						} else {
							htmlbox += '<td>'+noText+'</td>';
						}
						htmlbox += '<td class="prod-result-contact"><a href="https://member.ushio.co.jp/'+lang+'/members/contact/product-led/=/product='+_list[i]._key+'" class="prod-result-contactBtn" target="_blank">'+inquiryText+'</a></td>'+
						'</tr>';
					}
					htmlBlock.append(htmlbox);
				}
			} else {
				// led・ld、jsファイル切り分け済み
				if(directory === 'led') {
					moreItem = {
						ent_pled_name: _list[i].ent_pled_name, // 製品名
						_key: _list[i]._key, // 製品ID
						ent_pled_wave_length: _list[i].ent_pled_wave_length, // 発振波長
						ent_pled_package_type: _list[i].ent_pled_package_type, // パッケージタイプ
						ent_pled_package_family: _list[i].ent_pled_package_family, // パッケージファミリー
						ent_pled_package_size: _list[i].ent_pled_package_size, // パッケージサイズ
						ent_pled_output_power: _list[i].ent_pled_output_power, // 出力ランク
						ent_pled_forward_current: _list[i].ent_pled_forward_current, // 定格電流
						ent_pled_total_radiated_power: _list[i].ent_pled_total_radiated_power, // 光出力
						ent_pled_maximum_forward_current: _list[i].ent_pled_maximum_forward_current, // 最大定格電流（DC)
						ent_pled_maximum_pulse_forward_current: _list[i].ent_pled_maximum_pulse_forward_current, // 最大定格電流(Pulse)
						ent_pled_viewing_half_angle: _list[i].ent_pled_viewing_half_angle, // 配光角（Θ1/2）
						ent_pled_half_width: _list[i].ent_pled_half_width, // 波長スペクトルの半値幅
						ent_pled_3d_data: _list[i].ent_pled_3d_data, // 3D Data（例）aaa_3d.zip
						ent_pled_ray_file: _list[i].ent_pled_ray_file, // Ray File（例）aaa_ray.zip無い場合は空欄
						ent_pled_pdf_file: _list[i].ent_pled_pdf_file, // PDF FIle（例）aaa.pdf無い場合は空欄
						ent_pled_discontinued_production: _list[i].ent_pled_discontinued_production, // 廃止品（ディスコンの場合は「1」ディスコンではない場合は「0」）
					};
				}
				moreItemArray.push(moreItem);
			}
		}
	};
	// 50件ずつ出力イベント ---------------------------------------------------
	const moreHtmlSet = () => {
		let togetherHtml = '';
		count = 0;
		for(let item in moreItemArray) {
			if(count < 50) {
				// led・ld、jsファイル切り分け済み
				if($(window).width() < 1024) {
					togetherHtml += '<tr>'+
					'<td class="prod-result-name ta_left">'+
					'<ul class="pure-g pure-g-align_center">'+
					'<li class="pure-u-4-5 pr10"><div class="mr20">';
					// ディスコンだし分け
					if(!(moreItemArray[item].ent_pled_discontinued_production == '0')) {
						if(!(moreItemArray[item].ent_pled_discontinued_production == '1')) {
							togetherHtml += '<span class="prod-result-name_tag" style="background:#ffff00;color: #000;">NRND</span>'+
							'<span class="prod-result-name_txt">'+moreItemArray[item].ent_pled_name+'</span>'+
							'</li>'+
							'<li class="pure-u-1-5">';
						} else {
							togetherHtml += '<span class="prod-result-name_tag">DISCONTINUED</span>'+
							'<span class="prod-result-name_txt">'+moreItemArray[item].ent_pled_name+'</span>'+
							'</li>'+
							'<li class="pure-u-1-5">';
						}
					} else {
						togetherHtml += '<span class="prod-result-name_txt">'+moreItemArray[item].ent_pled_name+'</span>'+
						'</li>'+
						'<li class="pure-u-1-5">';
					}
					// PDFだし分け
					if(!(moreItemArray[item].ent_pled_pdf_file === '')) {
						togetherHtml += '<a href="/'+lang+'/products/product_file/file/'+moreItemArray[item].ent_pled_pdf_file+'" target="_blank" class="prod-result-name_pdf">'+
						'<img src="/assets/images/icon-pdf.png">'+
						'</a>'+
						'</li>'+
						'</ul>';
					} else {
						togetherHtml += '</li>'+
						'</ul>';
					}
					togetherHtml += '<a href="https://member.ushio.co.jp/'+lang+'/members/contact/product-led/=/product='+moreItemArray[item]._key+'" class="prod-result-contactBtn" target="_blank">'+inquiryText+'</a></td>'+
					'<td>'+moreItemArray[item].ent_pled_package_type+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_total_radiated_power+'</td>'+
					'</tr>';
				} else {
					togetherHtml += '<tr>'+
					'<td class="prod-result-name ta_left">'+
					'<ul class="pure-g pure-g-align_center">'+
					'<li class="pure-u-4-5 pr10">';
					// ディスコンだし分け
					if(!(moreItemArray[item].ent_pled_discontinued_production == '0')) {
						if(!(moreItemArray[item].ent_pled_discontinued_production == '1')) {
							togetherHtml += '<span class="prod-result-name_tag" style="background:#ffff00;color: #000;">NRND</span>'+
							'<span class="prod-result-name_txt">'+moreItemArray[item].ent_pled_name+'</span>'+
							'</li>'+
							'<li class="pure-u-1-5">';
						} else {
							togetherHtml += '<span class="prod-result-name_tag">DISCONTINUED</span>'+
							'<span class="prod-result-name_txt">'+moreItemArray[item].ent_pled_name+'</span>'+
							'</li>'+
							'<li class="pure-u-1-5">';
						}
					} else {
						togetherHtml += '<span class="prod-result-name_txt">'+moreItemArray[item].ent_pled_name+'</span>'+
						'</li>'+
						'<li class="pure-u-1-5">';
					}
					// PDFだし分け
					if(!(moreItemArray[item].ent_pled_pdf_file === '')) {
						togetherHtml += '<a href="/'+lang+'/products/product_file/file/'+moreItemArray[item].ent_pled_pdf_file+'" target="_blank" class="prod-result-name_pdf">'+
						'<img src="/assets/images/icon-pdf.png">'+
						'</a>'+
						'</li>'+
						'</ul>'+
						'</td>';
					} else {
						togetherHtml += '</li>'+
						'</ul>'+
						'</td>';
					}
					togetherHtml += '<td>'+moreItemArray[item].ent_pled_wave_length+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_package_type+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_package_family+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_package_size+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_output_power+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_forward_current+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_total_radiated_power+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_maximum_forward_current+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_maximum_pulse_forward_current+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_viewing_half_angle+'</td>'+
					'<td>'+moreItemArray[item].ent_pled_half_width+'</td>';
					// 3D Dataだし分け
					if(!(moreItemArray[item].ent_pled_3d_data === '')) {
						togetherHtml += '<td><a href="/'+lang+'/products/product_file/file/'+moreItemArray[item].ent_pled_3d_data+'" class="mod-link01" target="_blank">'+yesText+'</a></td>';
					} else {
						togetherHtml += '<td>'+noText+'</td>';
					}
					// レイファイルだし分け
					if(!(moreItemArray[item].ent_pled_ray_file === '')) {
						togetherHtml += '<td><a href="https://ushio-inc.s3-ap-northeast-1.amazonaws.com/led/rayfile/'+moreItemArray[item].ent_pled_ray_file+'" class="mod-link01" target="_blank">'+yesText+'</a></td>';
					} else {
						togetherHtml += '<td>'+noText+'</td>';
					}
					togetherHtml += '<td class="prod-result-contact"><a href="https://member.ushio.co.jp/'+lang+'/members/contact/product-led/=/product='+moreItemArray[item]._key+'" class="prod-result-contactBtn" target="_blank" target="_blank">'+inquiryText+'</a></td>'+
					'</tr>';
				}
				delete moreItemArray[item];
				count ++;
			}
		}
		if(!(count == 50)) {
			$('.js-product-more-button').addClass('di_none');
		}
		htmlBlock.append(togetherHtml);
	};
	// 絞り込みリスト用 ---------------------------------------------------
	let filterArray = [];
	let parameterKeys;
	let urlParam;
	// input要素・各入力ボタン ---------------------------------------------------
	const idUp = $('.js-sort-id .up');
	const idDown = $('.js-sort-id .down');
	const sortBtn = $('.js-sort button');
	const moreBtn = $('.js-product-more-button button');
	const prodNameSearchBtn = $('.js-product-name-search button');
	const wavelengthSearchBtn = $('.js-product-wavelength-search button');
	const checkInput = $('.prod-filter input');
	const totalListnum = $('.js-totalListNum');
	// json読み込み時イベント禁止・解除 ---------------------------------------------------
	const pointerEventsNone = () => {
		checkInput.css('pointer-events', 'none');
		sortBtn.css('pointer-events', 'none');
		prodNameSearchBtn.css('pointer-events', 'none');
		wavelengthSearchBtn.css('pointer-events', 'none');
		searchBlock.addClass('is-loading');
		searchBlock.removeClass('is-active');
	}
	const pointerEventsAuto = () => {
		checkInput.css('pointer-events', 'auto');
		sortBtn.css('pointer-events', 'auto');
		prodNameSearchBtn.css('pointer-events', 'auto');
		wavelengthSearchBtn.css('pointer-events', 'auto');
		searchBlock.removeClass('is-loading');
		searchBlock.addClass('is-active');
	}
	// JSON出力 ---------------------------------------------------
	const setJSON = () => {
		let setitemList = new Promise((_itemList) => {
			urlParam = location.search.substring(1);
			if(urlParam) {
				for(let i = 0; i < $('.prod-filter input[type="checkbox"]').length; i++) {
					if((urlParam.indexOf($('.prod-filter input[type="checkbox"]').eq(i).val()) !== -1) && (urlParam.indexOf($('.prod-filter input[type="checkbox"]').eq(i).data('group')) !== -1)) {
						$('.prod-filter input[type="checkbox"]').eq(i).prop('checked', true);
						$('.prod-filter input[type="checkbox"]').eq(i).parents('.prod-filter-list').addClass('is-active');
						$('.prod-filter input[type="checkbox"]').eq(i).parents('.prod-filter-list').prev('.prod-filter-tit').addClass('is-active');
					}
				}
				// パラメータ付きのjson読み込み・_itemList
				urlParam = '?'+urlParam;
				// led・ld、jsファイル切り分け済み
				getJSONledParameter(urlParam).then((data) => {
					return _itemList(setJSONList(data));
				});
			} else {
				// led・ld、jsファイル切り分け済み
				pointerEventsNone();
				getJSONled().then((data) => {
					return _itemList(setJSONList(data));
				});
			}
			pointerEventsNone();
		});
		setitemList.then((_itemList) => {
			let refineList = '';
			let serchnum, serchWord;
			// テキストエリアなどを見てhtml出力
			const inputValCheck = () => {
				// 製品名と波長欄がある場合
				if($('.js-product-wavelength-search').length) {
					if($('.js-product-wavelength-search input').val() && $('.js-product-name-search input').val()) {
						serchWord = $('.js-product-name-search input').val();
						refineList = _itemList.filter(item => {
							if(item.ent_pled_name.toLowerCase().indexOf(serchWord) !== -1) {
								return true;
							} else if(item.ent_pled_name.indexOf(serchWord) !== -1) {
								return true;
							} else {
								return false;
							}
						});
						serchnum = $('.js-product-wavelength-search input').val();
						refineList = refineList.filter(item => {
							// 1000nm以下は+/-15nm。
							if(Number(serchnum) < 1000) {
								for(let i = (Number(serchnum) - 15); i < (Number(serchnum) + 16); i++) {
									if(item.ent_pled_wave_length == i) {
										return true;
									} else if(item.ent_pled_wave_length.indexOf('<br>') !== -1) {
										if(item.ent_pled_wave_length.indexOf(i) !== -1) {
											return true;
										}
									}
								}
							} else if(Number(serchnum) > 999) { // 1000nm以下は+/-50nm。
								for(let i = (Number(serchnum) - 50); i < (Number(serchnum) + 51); i++) {
									if(item.ent_pled_wave_length == i) {
										return true;
									} else if(item.ent_pled_wave_length.indexOf('<br>') !== -1) {
										if(item.ent_pled_wave_length.indexOf(i) !== -1) {
											return true;
										}
									}
								}
							} else {
								return false;
							}
						});
						setHtml(refineList);
						totalListnum.text(refineList.length);
					} else if($('.js-product-name-search input').val()) {
						serchWord = $('.js-product-name-search input').val();
						refineList = _itemList.filter(item => {
							if(item.ent_pled_name.toLowerCase().indexOf(serchWord) !== -1) {
								return true;
							} else if(item.ent_pled_name.indexOf(serchWord) !== -1) {
								return true;
							} else {
								return false;
							}
						});
						setHtml(refineList);
						totalListnum.text(refineList.length);
					} else if($('.js-product-wavelength-search input').val()) {
						serchnum = $('.js-product-wavelength-search input').val();
						refineList = _itemList.filter(item => {
							// 1000nm以下は+/-15nm。
							if(Number(serchnum) < 1000) {
								for(let i = (Number(serchnum) - 15); i < (Number(serchnum) + 16); i++) {
									if(item.ent_pled_wave_length == i) {
										return true;
									} else if(item.ent_pled_wave_length.indexOf('<br>') !== -1) {
										if(item.ent_pled_wave_length.indexOf(i) !== -1) {
											return true;
										}
									}
								}
							} else if(Number(serchnum) > 999) { // 1000nm以下は+/-50nm。
								for(let i = (Number(serchnum) - 50); i < (Number(serchnum) + 51); i++) {
									if(item.ent_pled_wave_length == i) {
										return true;
									} else if(item.ent_pled_wave_length.indexOf('<br>') !== -1) {
										if(item.ent_pled_wave_length.indexOf(i) !== -1) {
											return true;
										}
									}
								}
							} else {
								return false;
							}
						});
						setHtml(refineList);
						totalListnum.text(refineList.length);
					} else {
						setHtml(_itemList);
						totalListnum.text(_itemList.length);
					}
				} else { // 製品欄のみの場合
					if($('.js-product-name-search input').val()) {
						serchWord = $('.js-product-name-search input').val();
						refineList = _itemList.filter(item => {
							if(item.ent_pled_name.toLowerCase().indexOf(serchWord) !== -1) {
								return true;
							} else if(item.ent_pled_name.indexOf(serchWord) !== -1) {
								return true;
							} else {
								return false;
							}
						});
						setHtml(refineList);
						totalListnum.text(refineList.length);
					} else {
						setHtml(_itemList);
						totalListnum.text(_itemList.length);
					}
				}
				sortBtn.removeClass('is-active');
			};

			// 初期表示
			pointerEventsAuto();
			inputValCheck();

			// チェックボックス・urlパラメータ設定・html出力
			const urlParamCheck = () => {
				urlParam = location.search.substring(1);
				if(urlParam) {
					for(let i = 0; i < $('.prod-filter input[type="checkbox"]').length; i++) {
						if((urlParam.indexOf($('.prod-filter input[type="checkbox"]').eq(i).val()) !== -1) && (urlParam.indexOf($('.prod-filter input[type="checkbox"]').eq(i).data('group')) !== -1)) {
							$('.prod-filter input[type="checkbox"]').eq(i).prop('checked', true);
							$('.prod-filter input[type="checkbox"]').eq(i).parents('.prod-filter-list').addClass('is-active');
							$('.prod-filter input[type="checkbox"]').eq(i).parents('.prod-filter-list').prev('.prod-filter-tit').addClass('is-active');
						}
					}
					// パラメータ付きのjson読み込み・_itemList
					urlParam = '?'+urlParam;
					// led・ld、jsファイル切り分け済み
					pointerEventsNone();
					getJSONledParameter(urlParam).done((_itemListParameter) => {
						_itemList = setJSONList(_itemListParameter);
						inputValCheck();
						pointerEventsAuto();
					});
				} else {
					// led・ld、jsファイル切り分け済み
					pointerEventsNone();
					getJSONled().done((item) => {
						_itemList = setJSONList(item);
						inputValCheck();
						pointerEventsAuto();
					});
				}
			};

			// ソートクリックイベント
			idUp.on('click', () => {
				sortBtn.removeClass('is-active');
				idUp.addClass('is-active');
				if(!refineList) {
					itemAscendingSort(_itemList, 'ent_pled_name');
					setHtml(_itemList);
				} else {
					itemAscendingSort(refineList, 'ent_pled_name');
					setHtml(refineList);
				}
			});
			idDown.on('click', () => {
				sortBtn.removeClass('is-active');
				idDown.addClass('is-active');
				if(!refineList) {
					itemDescendingSort(_itemList, 'ent_pled_name');
					setHtml(_itemList);
				} else {
					itemDescendingSort(refineList, 'ent_pled_name');
					setHtml(refineList);
				}
			});

			// 製品名検索
			prodNameSearchBtn.on('click', () => {
				inputValCheck();
			});
			if(!($(window).width() < 1025)) {
				$('.js-product-name-search input').keypress(function(e){
					if(e.which === 13) {
						inputValCheck();
					}
				});
			}
			// 波長手打ち検索
			wavelengthSearchBtn.on('click', () => {
				inputValCheck();
			});
			if(!($(window).width() < 1025)) {
				$('.js-product-wavelength-search input').keypress(function(e){
					if(e.which === 13) {
						inputValCheck();
					}
				});
			}
			// 50以降のものをもっとみるで表示
			moreBtn.on('click', () => {
				moreHtmlSet();
			});

			// 絞り込み解除
			$('.js-filterClear').on('click', () => {
				window.location.href = '/'+lang+'/'+directory+'/products/';
			});

			// 絞り込みチェックボックス
			$('.prod-filter input[type="checkbox"]').change(function(){
				sortBtn.removeClass('is-active');
				window.history.pushState(null, null, null);

				parameterKeys = '';
				filterArray = [];
				let truechackBoxs = $('.prod-filter input[type="checkbox"]');

				for(let i = 0; i < truechackBoxs.length; i++) {
					if(truechackBoxs.eq(i).prop('checked')) {
						filterArray.push('&'+truechackBoxs.eq(i).data('group')+'='+truechackBoxs.eq(i).val());
					}
				}
				$.each(filterArray, function(index, val){
					parameterKeys += val;
				});
				parameterKeys = parameterKeys.slice(1);
				parameterKeys = '?'+parameterKeys;
				window.history.pushState(null, null, parameterKeys);

				urlParamCheck();
			});
		});
	};
	setJSON();

})(window.jQuery, window.USHIO);
